import React from 'react';
import { Icon } from 'components/atoms';
import { SearchContainer } from './table-style';

const Search = props => {
  const { searchEnabled, legend, searchValue, onChange } = props;
  return searchEnabled || legend ? (
    <SearchContainer>
      {searchEnabled && (
        <div>
          <Icon name='search' size='1rem' />
          <input value={searchValue} onChange={onChange} placeholder='Filter' />
        </div>
      )}
      {Boolean(legend) && <div>{legend}</div>}
    </SearchContainer>
  ) : null;
};

export default Search;
